import React from "react";
import { Modal, Box, Typography } from "@mui/material";
import {
  sxColumnCenter,
  sxColumnCenterStart,
  sxText1430020,
  sxText3070036,
} from "../../theme/sxStyle";
import CustomSlider from "./CustomSlider";
import introModalImg from "../../assets/introModalImg.png";
import logoImage2 from "../../assets/logoImage2.svg";

const IntroModal = ({ open, handleClose }) => {

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          ...sxColumnCenterStart,
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          borderRadius: "0",
          background: "rgba(245, 246, 247, 1)",
          overflow: "auto",
          // py: "32px",
        }}
      >
        <Box
          sx={{
            ...sxColumnCenter,
            width: "100%",
            maxWidth: "400px",
            padding: "16px",
          }}
        >
          <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Box
              position={"relative"}
              width={"100%"}
              borderRadius="0 !important"
              sx={sxColumnCenter}
            >
              <Box
                component={"img"}
                src={introModalImg}
                alt="landing"
                width="calc(100% + 16px)"
                maxWidth={"600px"}
                minHeight={"460px"}
                height="auto"
                sx={{
                  objectFit: "cover",
                  borderRadius: "32px !important",
                }}
              />
              <Box
                position={"absolute"}
                width="calc(100% + 16px)"
                height={"100%"}
                sx={{
                  background: 'linear-gradient(180deg, rgba(33, 37, 41, 0) 23.31%, #212529 100%)',
                  borderRadius: "32px !important",
                }}
              />
              <Box
                position={"absolute"}
                bottom={"40px"}
                left={"50%"}
                gap={1}
                width={"100%"}
                maxWidth={"262px"}
                mt={"20px"}
                sx={{
                  ...sxColumnCenter,
                  transform: "translateX(-50%)",
                }}
              >
                <Box
                  component={"img"}
                  src={logoImage2}
                  alt="logo"
                  width={"50px"}
                  height={"auto"}
                />
                <Typography
                  variant={"h2"}
                  color={"#fff"}
                  textAlign={"center"}
                  sx={sxText3070036}
                >
                  Welcome to
                </Typography>
                <Typography
                  variant={"h1"}
                  color={"#fff"}
                  textAlign={"center"}
                  mt={"-8px"}
                  sx={sxText3070036}
                >
                  Travel Companion
                </Typography>
                <Typography
                  variant="body1"
                  color={"#fff"}
                  textAlign={"center"}
                  sx={sxText1430020}
                >
                  "Your Live-Streaming Travel Guide Anywhere, Anytime."
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{ ...sxColumnCenter, width: "100%" }}>
            <CustomSlider 
              isIntroModal={true} 
              onClose={handleClose}
            />
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default IntroModal;
